
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const WifiIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M10.0089 25.9522C14.6912 21.7253 26.9387 13 47.9993 13C69.0598 13 81.3082 21.7252 85.9909 25.952C88.6217 28.3268 88.6344 32.0223 86.9108 34.5546L55.2335 81.0933C51.7607 86.1953 44.2395 86.1953 40.7667 81.0933L9.0893 34.5545C7.36578 32.0223 7.3783 28.327 10.0089 25.9522ZM15.0354 30.8498L46.5534 77.1545C47.248 78.1749 48.7522 78.1749 49.4468 77.1545L80.9648 30.8499C76.9747 27.3596 66.4045 20 47.9993 20C29.5941 20 19.0249 27.3595 15.0354 30.8498Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M43.66 79.1239L11.9826 32.585C11.1047 31.2953 11.1961 29.5956 12.3542 28.5502C16.5498 24.7626 27.995 16.5 47.9992 16.5C68.0034 16.5 79.4496 24.7626 83.6457 28.5501C84.8039 29.5956 84.8954 31.2954 84.0174 32.5852L52.3401 79.1239C50.2564 82.1851 45.7437 82.1851 43.66 79.1239Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M10.0089 25.9522C14.6912 21.7253 26.9387 13 47.9993 13C69.0598 13 81.3082 21.7252 85.9909 25.952C88.6217 28.3268 88.6344 32.0223 86.9108 34.5546L55.2335 81.0933C51.7607 86.1953 44.2395 86.1953 40.7667 81.0933L9.0893 34.5545C7.36578 32.0223 7.3783 28.327 10.0089 25.9522ZM15.0354 30.8498L46.5534 77.1545C47.248 78.1749 48.7522 78.1749 49.4468 77.1545L80.9648 30.8499C76.9747 27.3596 66.4045 20 47.9993 20C29.5941 20 19.0249 27.3595 15.0354 30.8498Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M43.66 79.1239L11.9826 32.585C11.1047 31.2953 11.1961 29.5956 12.3542 28.5502C16.5498 24.7626 27.995 16.5 47.9992 16.5C68.0034 16.5 79.4496 24.7626 83.6457 28.5501C84.8039 29.5956 84.8954 31.2954 84.0174 32.5852L52.3401 79.1239C50.2564 82.1851 45.7437 82.1851 43.66 79.1239Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
